(function () {
    'use strict';
    var m = angular.module('common');
    m.factory('limitedArrayConverter', function () {
        return function (text, args) {
            if (!_(text).isArray() || text.length === 0) {
                return text;
            }
            if (args.uniqueCountText) {
                var uniqueValues = {};
                _(text).each(function (el, idx) {
                    if (args.uniqueTrim) {
                        el = $.trim(el);
                    }
                    if (!uniqueValues[el]) {
                        uniqueValues[el] = {
                            text: el,
                            count: 0,
                            first: idx
                        };
                    }
                    uniqueValues[el].count++;
                });
                text = _(uniqueValues).chain().map(function (el) {
                    return el;
                }).sortBy('firstIdx').map(function (el) {
                    return el.text + (el.count > 1 ? ' (' + el.count + ' ' + args.uniqueCountText + ')' : '');
                }).value();
            }
            var countText;
            if (args.collapseRest && !args.showAll) {
                countText = (args.countPrefix ? args.countPrefix + ' ' : '') + (text.length - (args.expanded || 1)) + ' more';
            } else {
                countText = (args.countPrefix ? args.countPrefix + ' ' : '') + text.length + (args.countPostfix ? ' ' + args.countPostfix : '');
            }
            var display = 'inline-list';
            var textData;
            var expandedData = [];
            if (!_(args.isHtml).isUndefined()) {
                display = 'html';
                textData = '';
                var foundStartComment = false;
                var isPassable = function (txt) {
                    if (txt && txt.indexOf('<!--') !== -1) {
                        foundStartComment = true;
                    }
                    if (foundStartComment && txt && txt.indexOf('-->') !== -1) {
                        foundStartComment = false;
                        return false;
                    }
                    return !foundStartComment;
                };
                _(text).each(function (label) {
                    if (isPassable(label)) {
                        textData += label;
                    }
                });
                return '#' + JSON.stringify({
                    display: display,
                    text: textData
                });
            } else {
                textData = _(text).map(function (label, key) {
                    if (args.expanded && key < args.expanded) {
                        if (text.length > args.expanded && args.showAll && args.name && key === args.expanded - 1) {
                            var newStr = label;
                            if (!_(label).isObject() && label.indexOf('#{') === -1) {
                                newStr = '#' + JSON.stringify({
                                    display: label && label.indexOf('#') !== -1 ? 'linked-text' : 'text',
                                    text: label + ' ...',
                                    'class': 'meta-info-col left-col'
                                });
                            }
                            expandedData.push(newStr + '#' + JSON.stringify({
                                display: 'text',
                                text: 'Show all',
                                'class': 'link-like show-all-user-emails-link meta-info-col right-col',
                                clickEvent: { name: 'show-all-' + args.name }
                            }));
                        } else {
                            expandedData.push(label);
                        }
                    }
                    return label;
                });
            }
            var obj = {
                display: display,
                data: textData,
                countText: countText,
                expanded: args.expanded,
                collapseRest: args.collapseRest,
                options: { 'class': args.rowClass }
            };
            if (args.showAll && args.name && args.expanded) {
                obj.showAll = args.showAll;
                obj.name = args.name;
                obj.expandedData = expandedData;
            }
            return '#' + JSON.stringify(obj);
        };
    });
}());